
















































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { ActionMethod } from "vuex";
import moment from "moment";
import SignalRHub from "@/services/SignalRHub";
import { PersonFormatter } from "@/services/personFormatter";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import {
  ReferralEspoedDetailsModel,
  RelatedReferralModel,
  Attachment,
  Sign,
  SignValue,
} from "@/types/aznconnect_api";
import DetailPaneRelatedReferrals from "@/components/DetailPaneRelatedReferrals.vue";
import ReferralIcon from "@/components/ReferralIcon.vue";
import Timings from "@/components/espoed/Timings.vue";
import InformationCard from "@/components/InformationCard.vue";
import InformationCardValues from "@/components/InformationCardValues.vue";
import DefaultPatientSearchDialog from "@/components/espoed/DefaultPatientSearchDialog.vue";
import TrendLineChart from "@/components/TrendLineChart.vue";
import { LabeledText, UrgencyCode } from "@/types/types";
import ProfessionalSummaryDetailPane from "@/components/professionalsummary/DetailPane.vue";

@Component({
  components: {
    "detail-pane-related-referrals": DetailPaneRelatedReferrals,
    "information-card": InformationCard,
    "information-card-values": InformationCardValues,
    "referral-icon": ReferralIcon,
    timings: Timings,
    "default-patient-search-dialog": DefaultPatientSearchDialog,
    "trendline-chart": TrendLineChart,
    "professional-summary-detail-pane": ProfessionalSummaryDetailPane,
  },
})
export default class DetailPane extends Vue {
  @Prop({ default: null })
  referral!: ReferralEspoedDetailsModel;

  @Prop({ default: null })
  relatedReferrals!: RelatedReferralModel[];

  @Prop({ default: null })
  referralState!: string;

  @Prop({ default: false })
  isReadOnly!: boolean;

  @Prop({ default: false })
  allowLinkPatientNumber!: boolean;

  @Prop({ default: false })
  allowSetReferralState!: boolean;

  @Prop({ default: false })
  allowProfessionalSummary!: boolean;

  @Prop({ default: true })
  allowPageClose!: boolean;

  @Prop({ default: "" })
  patientNumber!: string;

  @Prop({ default: null })
  signalRHub!: SignalRHub;

  @Action("resolveReferral", { namespace: "espoed" })
  resolveReferralAction!: ActionMethod;

  @Watch("referral", { immediate: true }) onPropChanged(
    value: ReferralEspoedDetailsModel,
    oldValue: ReferralEspoedDetailsModel,
  ) {
    this.signTimestamps = this.sortSignTimestamps();
  }

  resolveReferral(): void {
    this.resolveReferralAction(this.referral.Reference);
  }

  isEditingPatientNumber: boolean = false;
  showImageDialog: boolean = false;
  signTimestamps: Array<string> = [];
  attachmentPreviewText: string | null = null;
  attachmentPreviewUrl: string = "";
  failedToLoad: boolean = false;

  developerMode: boolean = false;
  advancedMode: boolean = false;
  psMode: boolean = false;

  showSignChart: boolean = false;
  signChartData: any = {};
  signChartOptions: any = {};

  professionalSummaryEnabled: boolean = false;

  get patientInformationValues(): Array<LabeledText> {
    const formatDate = Vue.filter("formatDate");
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    let birthDate = "";
    if (referralModel.PatientBirthDate) {
      birthDate = formatDate(referralModel.PatientBirthDate);
      if (referralModel.PatientAge != null) {
        birthDate = birthDate + " (" + referralModel.PatientAge + " jaar)";
      }
    }
    values.push(new LabeledText("Geboortedatum", birthDate));
    values.push(new LabeledText("BSN", referralModel.PatientBSN));
    values.push(
      new LabeledText(
        "Adres",
        `${referralModel.PatientAddressLine1}, ${
          referralModel.PatientAddressLine2
        }`,
      ),
    );

    const practitioner = PersonFormatter.formatPractitioner(
      referralModel.GeneralPractitionerName,
      referralModel.GeneralPractitionerAgbCode,
    );
    values.push(new LabeledText("Huisarts", practitioner));

    return values;
  }

  get rideInformationValues(): Array<LabeledText> {
    const formatDate = Vue.filter("formatDate");
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;
    values.push(
      new LabeledText(
        "Datum",
        formatDate(referralModel.DepartureTime.DateTime),
      ),
    );
    values.push(
      new LabeledText("Vertrek locatie", referralModel.DepartureLocation || ""),
    );
    values.push(new LabeledText("Ritnummer", referralModel.Reference || ""));
    values.push(new LabeledText("Ambulance", referralModel.AmbulanceId || ""));

    return values;
  }

  get anamneseValues(): Array<LabeledText> {
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    if (referralModel && referralModel.SecondarySurveys) {
      for (const secondarySurvey of referralModel.SecondarySurveys) {
        values.push(
          new LabeledText(secondarySurvey.Name, secondarySurvey.Value),
        );
      }
    }

    return values;
  }

  get mechanismValues(): Array<LabeledText> {
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    if (
      referralModel &&
      referralModel.MechanismObservations &&
      referralModel.MechanismObservations.length > 0
    ) {
      for (const mechanismObservation of referralModel.MechanismObservations) {
        values.push(
          new LabeledText(
            mechanismObservation.Code,
            mechanismObservation.Value,
          ),
        );
      }
    } else if (
      referralModel &&
      referralModel.Mechanisms &&
      referralModel.Mechanisms.length == 0
    ) {
      values.push(new LabeledText("Geen", ""));
    }
    return values;
  }

  get injuryValues(): Array<LabeledText> {
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;
    if (referralModel && referralModel.InjuryObservations) {
      for (const injuryObservation of referralModel.InjuryObservations) {
        values.push(
          new LabeledText(
            `${injuryObservation.Code}`,
            `${injuryObservation.Value}`,
          ),
        );
      }
    }

    values.push(
      new LabeledText(
        "Extra informatie",
        this.filters.formatExtraInformation(
          referralModel.InjuryAdditionalInformation,
        ),
      ),
    );
    return values;
  }

  sortSignTimestamps(): Array<string> {
    let signTimestamps = [];
    if (this.referral && this.referral.Signs) {
      for (const sign of this.referral.Signs) {
        for (const signValue of sign.Values) {
          if (signTimestamps.find(t => t == signValue.Timestring) == null) {
            signTimestamps.push(signValue.Timestring);
          }
        }
      }
    }
    return signTimestamps.sort();
  }

  get filters(): any {
    return this.$options.filters || {};
  }

  signOnClickHandler(sign: Sign): void {
    let vm = this;
    var signChartDataValues: Array<number> = [];
    var calculatedMaxY: number = 0;

    var ascendingTimestamps = this.signTimestamps.sort();

    ascendingTimestamps.forEach(signTimestamp => {
      var stringValue = vm.getSignValue(sign, signTimestamp);
      var numberValue = Number.parseInt(stringValue);

      if (numberValue && numberValue > calculatedMaxY) {
        calculatedMaxY = numberValue * 1.2;
      }

      signChartDataValues.push(numberValue);
    });

    var timestamps = ascendingTimestamps.map(x => this.filters.formatTime(x));

    this.signChartData = {
      labels: timestamps,
      datasets: [
        {
          label: sign.Name,
          fill: false,
          lineTension: 0.2,
          backgroundColor: "#181E3C",
          borderColor: "#181E3C",
          data: signChartDataValues,
        },
      ],
    };

    this.signChartOptions = {
      legend: {
        display: true,
        position: "top",
        labels: {
          fontFamily: "Roboto, sans-serif",
          boxWidth: 16,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              suggestedMin: 0,
              suggestedMax: calculatedMaxY,
            },
          },
        ],
      },
      title: {
        display: false,
        text: sign.Name,
      },
    };

    this.showSignChart = true;
  }

  copyLinkToClipboard(): void {
    const route = this.$router.resolve({
      name: "referral-details",
      params: { referralId: this.referral.Reference || "" },
    });
    const url = window.location.origin + "/" + route.href;

    var temp = $("<input>");
    $("body").append(temp);
    temp.val(url).select();
    document.execCommand("copy");
    temp.remove();
  }

  getSignValue(sign: Sign, timestamp: string): string {
    const signValue: SignValue | undefined = sign.Values.find(
      value => value.Timestring == timestamp,
    );
    return signValue ? signValue.Value : "";
  }

  getSignUnit(sign: Sign) {
    var displayValue = "";
    if (sign != null) {
      displayValue += sign.Value;
      if (sign.Unit) {
        displayValue += " " + sign.Unit;
      }
      if (sign.DenominatorUnit) {
        displayValue += " / ";
        if (sign.DenominatorValue && sign.DenominatorValue !== "1") {
          displayValue += sign.DenominatorValue;
        }
        displayValue += sign.DenominatorUnit;
      }
    }
    return displayValue;
  }

  previewAttachment(attachment: Attachment): void {
    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, attachment.Open)
      .then(response => {
        // Create temporary link to preserve filename
        this.attachmentPreviewText = attachment.Text;
        this.attachmentPreviewUrl = response.data;
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  closeAttachmentPreview(): void {
    // Revoke URL to free memory
    this.attachmentPreviewText = null;
    this.attachmentPreviewUrl = "";
  }

  isImage(attachment: Attachment): boolean {
    // Extract extension from filename
    const filename = attachment.Text || "";
    const lastDotIndex = filename.lastIndexOf(".");
    let extension = "";

    if (lastDotIndex > 0 && lastDotIndex < filename.length - 1) {
      extension = filename.substring(lastDotIndex + 1).toLowerCase();
    } else if (attachment.Download.FileType) {
      extension = attachment.Download.FileType.toLowerCase();
    }

    return (
      extension === "jpg" ||
      extension === "jpeg" ||
      extension === "png" ||
      extension === "gif" ||
      extension === "bmp" ||
      extension === "webp"
    );
  }

  getMimeTypeFromExtension(fileType: string | null): string {
    if (!fileType) return "application/octet-stream";

    const ext = fileType.toLowerCase();
    const mimeTypes: { [key: string]: string } = {
      // Images
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      bmp: "image/bmp",
      webp: "image/webp",
      svg: "image/svg+xml",
      // Documents
      pdf: "application/pdf",
      doc: "application/msword",
      docx:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ppt: "application/vnd.ms-powerpoint",
      pptx:
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      txt: "text/plain",
      csv: "text/csv",
      xml: "application/xml",
      json: "application/json",
      // Archives
      zip: "application/zip",
      rar: "application/x-rar-compressed",
      "7z": "application/x-7z-compressed",
    };

    return mimeTypes[ext] || "application/octet-stream";
  }

  openAttachment(attachment: Attachment): void {
    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, attachment.Open)
      .then(response => {
        // Create temporary link to preserve filename
        const link = document.createElement("a");
        link.href = response.data;
        link.target = "_blank";
        link.download = attachment.Text;

        //For PDFs and images, remove download attribute to view in browser
        if (
          attachment.Open.FileType === "pdf" ||
          attachment.Open.FileType === "image"
        ) {
          link.removeAttribute("download");
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  downloadAttachment(attachment: Attachment): void {
    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, attachment.Download)
      .then(response => {
        window.location.href = response.data;
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  toggleDeveloperMode(): void {
    var me = this;
    me.developerMode = !me.developerMode;
  }

  toggleAdvancedMode(): void {
    var me = this;
    me.advancedMode = !me.advancedMode;
  }

  closeDetails(): void {
    this.$emit("close");
  }

  destroyed() {
    // Clean up preview URL
    this.attachmentPreviewText = null;
    this.attachmentPreviewUrl = "";
    this.$emit("closed");
  }
}
